import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserNameLink from "../userControl/components/UserNameLink";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
function ReferralUserList() {
  const [newID, setNewID] = useState(null);
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("paid");
 
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef();
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [filterType, setFilterType] = useState(""); // course | contest | both
const [selectedContest, setSelectedContest] = useState("");
const [contestList, setContestList] = useState([]);


  // useEffect(() => {
  //   async function fetchData() {
  //     axios.get("getPaidUsers").then((response) => {
  //       console.log((response?.data))
  //       if (response?.data) {
  //         setData(response?.data?.result);
  //         localStorage.setItem("plans", JSON.stringify(response?.data?.result));
  //       }
  //     });
  //   }
  //   fetchData();
  // }, []);

  const fetchUsers = async (type) => {
    try {
    
      const res = await axios.get("getAllUsers");

     if ((res?.data?.result.users && Array.isArray(res.data.result.users)) || (res?.data?.result && Array.isArray(res.data.result))) {
  setData(res.data.result.users || res.data.result);
} else {
  setData([]);
}
    } catch (err) {
      errorToast("Failed to fetch users");
    }
  };
  useEffect(() => {
    fetchUsers(activeTab);
  }, [activeTab]);

  const filteredData = useMemo(() => {
  if (!search) return data;

  return data.filter((user) =>
    user.name?.toLowerCase().includes(search.toLowerCase()) ||
    user.email?.toLowerCase().includes(search.toLowerCase())
  );
}, [search, data]);

const contestMap = useMemo(() => {
  const map = {};

  contestList.forEach((c) => {
    map[c._id] = c.contestName;
  });

  return map;
}, [contestList]);

const processedData = useMemo(() => {
  let temp = [...data];

  // SEARCH
  if (search) {
    temp = temp.filter((user) =>
      user.name?.toLowerCase().includes(search.toLowerCase()) ||
      user.email?.toLowerCase().includes(search.toLowerCase())
    );
  }

  // ✅ TYPE FILTER
  if (filterType === "course") {
    temp = temp.filter((user) => user.planName); // course users
  }

  if (filterType === "contest") {
    temp = temp.filter((user) => user.contestId || user.contestName);
  }

  if (filterType === "both") {
    // optional: dono show (no filter needed)
  }

  // ✅ CONTEST FILTER (specific contest)
if (selectedContest) {
  temp = temp.filter((user) => {
    return user.joinedContests?.includes(selectedContest);
  });
}

  // SORT (same as before)
  if (sortBy === "latest") {
    temp.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
  }

  return temp;
}, [data, search, sortBy, filterType, selectedContest]);

useEffect(() => {
  axios.get("getAllContestForAdmin").then((res) => {
    const contests =
      res?.data?.result?.contests || // most common
      res?.data?.result || 
      [];

    setContestList(Array.isArray(contests) ? contests : []);
  });
}, []);

const handleShare = async (user) => {
  const referralCode = user?.referralCode;

  if (!referralCode) {
    errorToast("Referral code not found");
    return;
  }

  const shareableLink = `https://adhyayi.com/login?ref=${referralCode}`;

  const shareText = `🎓 Join Adhyayi and start earning while learning!

Use my referral code: ${referralCode}

${shareableLink}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: "Refer & Earn",
        text: shareText,
        url: shareableLink,
      });
      return;
    } catch (err) {
      console.log(err);
    }
  }

  window.open(
    `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`,
    "_blank"
  );
};

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "srNo",
        Cell: ({ value, row: { index } }) => <Cell text={index + 1} />,
      },
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?._id}
              name={value}
              planName={original?.planName}
              email={original?.email}
            />
            <div className="flex items-center justify-center gap-2 text-13 mt-2">
              <div className="flex gap-2 ">
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-green">
                    {original?.quizStats?.totalRight}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-red">
                    {original?.quizStats?.totalWrong}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-yellow-500">
                    {original?.quizStats?.totalSkipped}
                  </h1>
                </div>
              </div>
              {/* <div className="py-1 shadow-md px-2 bg-bgWhite text-black border-1 border-coolGray rounded-lg flex flex-col-2 gap-2 items-center justify-items-center">
                <Image
                  alt="Rate"
                  src={rateIcon}
                  width={20}
                  height={20}
                  layout="fixed"
                />

                <div className="text-center">
                  {original?.planName === "Silver"
                    ? 3000
                    : original?.planName === "Silver Plus"
                    ? 2000
                    : original?.planName === "Gold"
                    ? 1500
                    : original?.planName === "Platinum"
                    ? 1000
                    : 3000}
                  /1$
                </div>
              </div> */}
            </div>
          </>
        ),
      },

      {
        Header: "Ammount Paid",
        accessor: "amount",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`Rs. ${value}`} className="font-bold text-green-600"  />
          </>
        ),
      },
      {
        Header: "Remaining Balance",
        accessor: "remaining",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`Rs. ${Math.ceil(value)}`} />
          </>
        ),
      },
      // {
      //   Header: "PaymentMethod",
      //   accessor: "paymentMethod",
      //   Cell: ({ value, row: { original } }) => (
      //     <>
      //       <Cell text={value==null?"Other":`${value}`} />
      //     </>
      //   ),
      // },
      {
        Header: "Platform",
        accessor: "platform",
        Cell: ({ value, row: { original } }) => <Cell text={value} />,
      },

      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },
      {
        Header: "Total Earning (Rs)",
        accessor: "unifiedWallet.balance",
        Cell: ({ value, row: { original } }) => (
          <Cell text={`${Math.ceil(value)}`} />
        ),
      },
      // {
      //   Header: "Wallet Balance (Rs.)",
      //   accessor: "currentEarning",
      //   Cell: ({
      //     value,
      //     row: {
      //       original: { rate, rightCount },
      //     },
      //   }) => {
      //     return <Cell text={`Rs. ${Math.round(rightCount * rate)}`} />;
      //   },
      // },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
            <Button
  className="bg-purple-800 text-white"
  onClick={() => handleShare(original)}
>
  Share
</Button>
              </Menu>
            </>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  );

  return (
    <div
      className="lg:py-8 py-4 bg-bgBlue"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <section class=" md:p-1 ">
        <div class="py-4 ">
          <div class="flex  justify-between items-center">
            {/* <div>
              <h2 class="text-xl font-bold  mb-4 text-purple text-oswald pl-5">
                Active User
              </h2>
            </div> */}
            {/* <Tabs
              variant="soft-rounded"
              colorScheme="purple"
              onChange={(index) => {
                if (index === 0) setActiveTab("all");
                if (index === 1) setActiveTab("paid");
                if (index === 2) setActiveTab("demo");
              }}
            >
              <TabList mb={4}>
                <Tab className="bg-purple-100 text-white">All Users</Tab>
                <Tab className="bg-purple-100 text-white">Active Users</Tab>
                <Tab className="bg-purple-100 text-white">New Users</Tab>
              </TabList>
            </Tabs> */}
            <div className=" w-96">
              <InputGroup borderRadius={5} size="sm">
                <InputLeftElement
                  pointerEvents="none"
                  // children={<Search2Icon color="gray.600" />}
                />
               <Input
  type="text"
  placeholder="Search..."
  border="1px solid #949494"
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>
                <InputRightAddon p={0} border="none">
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div>

            <div className="flex gap-2">
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#4D2C5E"
                  zIndex={20}
                  className="bg-bgBlue"
                >
                  Sort By
                </MenuButton>
               <MenuList>
  <MenuItem onClick={() => setSortBy("latest")}>
    Latest First
  </MenuItem>
  <MenuItem onClick={() => setSortBy("oldest")}>
    Oldest First
  </MenuItem>
  <MenuItem onClick={() => setSortBy("amountHigh")}>
    Amount High → Low
  </MenuItem>
  <MenuItem onClick={() => setSortBy("amountLow")}>
    Amount Low → High
  </MenuItem>
</MenuList>
              </Menu>
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#FF782D"
                  zIndex={20}
                  className="bg-purple"
                  ref={btnRef}
                  onClick={onOpen2}
                >
                  Filter By
                </MenuButton>
              </Menu>
            </div>
            <Drawer
              isOpen={isOpen2}
              placement="right"
              onClose={onClose2}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Create your account</DrawerHeader>

             <DrawerBody>
  {/* TYPE FILTER */}
  <select
    className="w-full border p-2 rounded mb-4"
    onChange={(e) => setFilterType(e.target.value)}
  >
    <option value="">All</option>
    <option value="course">Only Course</option>
    <option value="contest">Only Contest</option>
    <option value="both">Both</option>
  </select>

  {/* CONTEST FILTER */}
<select
  className="w-full border p-2 rounded"
  value={selectedContest}
  onChange={(e) => setSelectedContest(e.target.value)}
>
  <option value="">All Contest</option>

  {contestList.map((c) => (
    <option key={c._id} value={c._id}>
      {c.contestName}
    </option>
  ))}
</select>
</DrawerBody>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose2}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          </div>
          <div className="mt-2">
            <Table
              // isLoading={isLoading}
             data={Array.isArray(processedData) ? processedData : []}
              columns={columns}
              // total={data?.total}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ReferralUserList;
